import { Component, Input } from '@angular/core';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-popup-msg-oc',
  templateUrl: './popup-msg-oc.component.html',
  styleUrls: ['./popup-msg-oc.component.css'],
  standalone: true,
  imports: [DatePipe]
})
export class PopupMsgOcComponent {
  @Input() mensagem: string = '';
  @Input() data: string = '';
  @Input() ocorrencia: any;

  constructor(
      public boxInfoAlertService: BoxInfoAlertService
    ) { }
  
  ngOnInit() {
      this.boxInfoAlertService.mensagemOcorrenciaEvent$.subscribe((dados) => {
      this.mensagem = dados.mensagem; 
      this.data = dados.data;
    });
  }

  fecharModal(){
    this.boxInfoAlertService.abrirModalMensagemOc = !this.boxInfoAlertService.abrirModalMensagemOc;
  }

  onAbrirOcorrencia() {
    const item = this.boxInfoAlertService.ocorrenciaAtualModal;
    this.boxInfoAlertService.abrirOcorrenciaCallback?.(item);
  }
}
